export default __webpack_public_path__ + "static/media/DEBIT_CARD.8b4bfa2a.svg";